  // src/assets/Categorias/productosData.js
  import { imagesDelice , imagesDelichizz, deliceQuesoCrema, deliceQuesoFresco, deliceQuesoMozzarella, deliceMantequilla, deliceQuesoMadurados, deliceQuesoGourmet, deliceDips, delichizzMozzarella, delichizzEdam, untadeliCrema, untadeliUntable, fricoMadurados} from "../../../../../assets/Categorias/images"; // Asegúrate de tener la ruta correcta para las imágenes

  export const productosData = {
    
    Delice: {
      qcrema: [
      { 
        id: 1,
        image: deliceQuesoCrema.img1,
        name: "Quesos Crema",
        description: " Queso Crema - Untable Delice Pote - 150 g.",
      },
      {
        id: 2,
        image: deliceQuesoCrema.img2,
        name: "Quesos Crema",
        description: " Queso Crema - Delice Caja - 190 g.",
      },
      {
        id: 3,
        image: deliceQuesoCrema.img3,
        name: "Quesos Crema",
        description: " Queso Crema Delice - Tipo Barra - 455 g.",
      },
      {
        id: 4,
        image: deliceQuesoCrema.img4,
        name: "Quesos Crema",
        description: " Queso Crema - Delice Caja - 90 g.",
      },
      {
        id: 5,
        image: deliceQuesoCrema.img5,
        name: "Quesos Crema",
        description: " Delice Caja - Untable Delice - Light Pote - 150 g.",
      },
      {
        id: 6,
        image: deliceQuesoCrema.img6,
        name: "Quesos Crema",
        description: " Queso Crema  - Delice Caja - 227 g.",
      },
      {
        id: 7,
        image: deliceQuesoCrema.img7,
        name: "Quesos Crema",
        description: " Queso Crema  - Natural Pote - 1 Kg.",
      },
      {
        id: 8,
        image: deliceQuesoCrema.img8,
        name: "Quesos Crema",
        description: " Queso Crema - Delice Bandeja - 5 Kg.",
      },
      
      {
        id: 9,
        image: deliceQuesoCrema.img9,
        name: "Quesos Crema",
        description: " Queso Crema - Delice- 14 g.  ",
      },
      {
        id: 10,
        image: deliceQuesoCrema.img10,
        name: "Quesos Cremas",
        description: " Queso Crema - Delice - 1.36 kg.",
      },
      {
        id: 11,
        image: deliceQuesoCrema.img64,
        name: "Leche Condensada",
        description: " Leche condensada en Bolsa - 13 Kg.",
      },
    ],
    qfresco: [
      {
        id: 1,
        image: deliceQuesoFresco.img11,
        name: "Quesos Fresco",
        description: " Queso Fresco - Delice con sal rectángular - 1 Kg. (Aprox.)",
      },
      {
        id: 2,
        image: deliceQuesoFresco.img12,
        name: "Quesos Fresco",
        description: " Queso Fresco - Delice sin sal rectángular - 1 Kg. (Aprox.)",
      },
      {
        id: 3,
        image: deliceQuesoFresco.img13,
        name: "Quesos Fresco",
        description: " Queso Fresco - Delice Redondo - 2 Kg. (Aprox.)",
      },
      {
        id: 4,
        image: deliceQuesoFresco.img14,
        name: "Quesos Fresco",
        description: " Queso Cottage - Delice Pote - 227 g.",
      },
    ],
    qmozarella: [
      {
        id: 1,
        image: deliceQuesoMozzarella.img15,
        name: "Quesos Mozzarella",
        description: " Queso Mozzarella - Rallada - 1 Kg. / 500 g.",
      },
      {
        id: 2,
        image: deliceQuesoMozzarella.img16,
        name: "Quesos Mozzarella",
        description: " Queso Mozzarella - Barra - 3.2 Kg. (Aprox.)",
      },
      {
        id: 3,
        image: deliceQuesoMozzarella.img17,
        name: "Quesos Mozzarella",
        description: " Queso Mozzarella - Bola - 250 g.",
      },
      {
        id: 4,
        image: deliceQuesoMozzarella.img18,
        name: "Quesos Mozzarella",
        description: " Queso Mozzarella - Rallada - 200 g.",
      },
      {
        id: 5,
        image: deliceQuesoMozzarella.img19,
        name: "Quesos Mozzarella",
        description: " Bocconcini Delice - 530 g. /210 g. (escurrido)",
      },
      {
        id: 6,
        image: deliceQuesoMozzarella.img20,
        name: "Quesos Mozzarella",
        description: " Palitos de Queso - Mozzarella - 180 g.",
      },
    ],
    qmantequilla: [
      {
        id: 1,
        image: deliceMantequilla.img21,
        name: "Mantequilla",
        description: " Mantequilla - C/S Sal Delice - 25 Kg. (Aprox.)",
      },
      {
        id: 2,
        image: deliceMantequilla.img22,
        name: "Quesos Fresco",
        description: " Mantequilla - sin sal Delice - 1 Kg. (Aprox.)",
      },
      {
        id: 3,
        image: deliceMantequilla.img23,
        name: "Quesos Fresco",
        description: " Mantequilla - con sal Delice - 1 Kg. - (Aprox.)",
      },
    ],
    qmadurados: [
      {
        id: 1,
        image: deliceQuesoMadurados.img24,
        name: "Quesos Madurados",
        description: " Queso Edam - Delice Laminado - 1 Kg.",
      },
      {
        id: 2,
        image: deliceQuesoMadurados.img25,
        name: "Quesos Madurados",
        description: " Queso Edam - Delice Laminado - 420 g.",
      },
      {
        id: 3,
        image: deliceQuesoMadurados.img26,
        name: "Quesos Madurados",
        description: " Queso Parmesano - Delice Cuña - 180 g. (Aprox.)",
      },
      {
        id: 4,
        image: deliceQuesoMadurados.img27,
        name: "Quesos Madurados",
        description: " Queso Edam en Tajadas - 85 g.",
      },
      {
        id: 5,
        image: deliceQuesoMadurados.img28,
        name: "Quesos Madurados",
        description: " Queso Edam en Tajadas - 180 g.",
      },
      {
        id: 6,
        image: deliceQuesoMadurados.img29,
        name: "Quesos Madurados",
        description: " Queso Parmesano - Delice Bloque - 4.2 Kg. (Aprox.)",
      },
      {
        id: 7,
        image: deliceQuesoMadurados.img30,
        name: "Quesos Madurados",
        description: " Queso Edam - Delice Barra - 3.2 Kg. (Aprox.)",
      },
      {
        id: 8,
        image: deliceQuesoMadurados.img31,
        name: "Quesos Madurados",
        description: " Queso Parmesano - Delice Rallado - 800 g.",
      },
    ],
    qgourmet: [
      {
        id: 1,
        image: deliceQuesoGourmet.img32,
        name: "Quesos Gourmet",
        description: " Queso Gourmet - Hindú - 150 g.",
      },
      {
        id: 2,
        image: deliceQuesoGourmet.img33,
        name: "Quesos Gourmet",
        description: " Queso Gourmet - Prosciutto & Poro - 150 g.",
      },
      {
        id: 3,
        image: deliceQuesoGourmet.img34,
        name: "Quesos Gourmet",
        description: " Queso Gourmet - Pecanas - 150 g.",
      },
      {
        id: 4,
        image: deliceQuesoGourmet.img35,
        name: "Quesos Gourmet",
        description: " Queso Gourmet - Cabanossi - 150 g.",
      },
      {
        id: 5,
        image: deliceQuesoGourmet.img36,
        name: "Quesos Gourmet",
        description: " Queso Gourmet - Espinaca & Tocino - 150g.",
      },
      {
        id: 6,
        image: deliceQuesoGourmet.img37,
        name: "Quesos Gourmet",
        description: " Queso Novandino -  Aguaymanto - 150 g.",
      },
      {
        id: 7,
        image: deliceQuesoGourmet.img38,
        name: "Quesos Gourmet",
        description: " Queso Novandino -  Sauco Delice - 150 g.",
      },
      {
        id: 8,
        image: deliceQuesoGourmet.img39,
        name: "Quesos Gourmet",
        description: " Mousse - Alcachofa Delice - 150 g.",
      },
     ],
     qdisp: [
      {
        id: 1,
        image: deliceDips.img40,
        name: "Dips",
        description: " Dip Acevichado - 140 g.",
      },
      {
        id: 2,
        image: deliceDips.img41,
        name: "Dips",
        description: " Dip Vegetariano - 140 g.",
      },
      {
        id: 3,
        image: deliceDips.img42,
        name: "Dips",
        description: "Dip Parrillero - 140 g.",
      },
      {
        id: 4,
        image: deliceDips.img43,
        name: "Dips",
        description: "Dip Marino - 140 g.",
      },
    ],
  },
    
    Delichizz: { 
      dmozzarella: [
      {
        id: 1,
        image: delichizzMozzarella.img44,
        name: "Tipo Mozzarella",
        description: " Tipo Mozzarella - Barra Delichizz - 3.2 kg. (Aprox)",
      },
      {
        id: 2,
        image: delichizzMozzarella.img45,
        name: "Tipo Mozzarella",
        description: " Tipo Mozzarella - Rallada Delichizz - 1 kg. 500 g.",
      },
      {
        id: 3,
        image: delichizzMozzarella.img46,
        name: "Tipo Mozzarella",
        description: " Tipo Mozzarella - Bola Delichizz - 250 g.",
      },
      {
        id: 4,
        image: delichizzMozzarella.img47,
        name: "Tipo Mozzarella",
        description: " Tipo Mozzarella - Rallada Delichizz  - 200 g.",
      },
      
    ],
    dedam: [
      {
        id: 1,
        image: delichizzEdam.img48,
        name: "Tipo Edam",
        description: " Tipo Edam - Laminado Delichizz - 1 kg.",
      },
      {
        id: 2,
        image: delichizzEdam.img49,
        name: "Tipo Edam",
        description: " Tipo Edam - Barra Delichizz - 3.2 kg. (Aprox.)",
      },
      {
        id: 3,
        image: delichizzEdam.img50,
        name: "Tipo Edam",
        description: " Tipo Edam - Laminado Delichizz - 85 g.",
      },
    ],
    dcrema: [
      {
        id: 4,
        image: delichizzEdam.img51,
        name: "Tipo Queso Crema",
        description: " Tipo Queso Crema - Delichizz  - 5 kg.",
      },
    ],
  },

    Untadeli: { 
      ucrema: [
      {
        id: 1,
        image: untadeliCrema.img52,
        name: "Crema Con Queso",
        description: " Crema con Queso - Untadeli Sachet - 80 g.",
      },
      {
        id: 2,
        image: untadeliCrema.img53,
        name: "Crema Con Queso",
        description: " Crema con Queso y Aceituna - Untadeli Sachet - 80 g.",
      },
      {
        id: 3,
        image: untadeliCrema.img54,
        name: "Crema Con Queso",
        description: " Crema con Queso y Finas Hierbas - Untadeli Sachet - 80 g.",
      },
      {
        id: 4,
        image: untadeliCrema.img55,
        name: "Crema Con Queso",
        description: " Crema con Queso y Tocino - UntadeliSachet - 80 g. ",
      },
    ],
    uuntable: [
      {
        id: 1,
        image: untadeliUntable.img56,
        name: "Crema Untable",
        description: " Crema Untable - Sabor Original Untadeli Pote - 140 g.",
      },
      {
        id: 2,
        image: untadeliUntable.img57,
        name: "Crema Untable",
        description: " Crema Untable con Aceitunas - Untadeli Pote - 140 g.",
      },
      {
        id: 3,
        image: untadeliUntable.img58,
        name: "Crema Untable",
        description: " Crema Untable - Sabor Pizza - Untadeli Pote - 140 g.",
      },
      {
        id: 4,
        image: untadeliUntable.img59,
        name: "Crema Untable",
        description: "  Crema Untable - Sabor Tocino - Untadeli Pote 140 g.",
      },
    ],
  },

    Frico: { 
      fmadurados: [
      {
        id: 1,
        image: fricoMadurados.img60,
        name: "Quesos Madurados",
        description: " Queso Emmental - Frico Laminado - 150 g.",
      },
      {
        id: 2,
        image: fricoMadurados.img61,
        name: "Quesos Madurados",
        description: " Queso Maasdam - Frico Laminado - 150 g.",
      },
      {
        id: 3,
        image: fricoMadurados.img62,
        name: "Quesos Madurados",
        description: " Queso Edam - Frico Laminado - 150 g. ",
      },
      {
        id: 4,
        image: fricoMadurados.img63,
        name: "Quesos Madurados",
        description: " Queso Gouda - Frico Laminado - 150 g.",
      },
      // {
      //   id: 5,
      //   image: fricoMadurados.img64,
      //   name: "Quesos Madurados",
      //   description: "Queso fundido de la mejor calidad para preparar tus platillos favoritos.",
      // },
      // {
      //   id: 6,
      //   image: fricoMadurados.img65,
      //   name: "Quesos Madurados",
      //   description: "Queso fundido de la mejor calidad para preparar tus platillos favoritos.",
      // },
      // {
      //   id: 7,
      //   image: fricoMadurados.img66,
      //   name: "Quesos Madurados",
      //   description: "Queso fundido de la mejor calidad para preparar tus platillos favoritos.",
      // },
      // {
      //   id: 8,
      //   image: fricoMadurados.img67,
      //   name: "Quesos Madurados",
      //   description: "Queso fundido de la mejor calidad para preparar tus platillos favoritos.",
      // },
    ]
    
    }
  }
